import * as React from 'react';
import { RowButton, TDSnapshot, TDStatus, useTldrawApp } from 'sn-wb-tldraw';

interface FollowingProps {
  user: any;
  spotLightUser: string;
  updateUserFollowing: any;
}

export const Following = React.memo(function Following({
  user,
  spotLightUser,
  updateUserFollowing,
}: FollowingProps) {
  const app = useTldrawApp();
  const currentCameraPoint = app.pageState.camera.point;
  const currentZoom = app.pageState.camera.zoom;
  const followedUser = user || {
    cameraPoint: currentCameraPoint,
    zoom: currentZoom,
  };
  const { cameraPoint, zoom } = followedUser;

  React.useEffect(() => {
    app.setCamera(cameraPoint, zoom, '');
  }, [cameraPoint, zoom]);

  React.useEffect(() => {
    const handleWheel = () => {
      updateUserFollowing('', currentCameraPoint);
    };
    window.addEventListener('wheel', handleWheel);

    return () => {
      window.removeEventListener('wheel', handleWheel);
    };
  }, []);

  return (
    <>
      {user && (
        <div
          className="absolute px-10 py-8 "
          style={{
            top: '32px',
            right: '50%',
            transform: 'translate(50%, 0%)',
            boxShadow: ' 0px 2px 12px rgba(19, 23, 32, 0.08)',
            borderRadius: '8px',
            background: '#fff',
          }}
        >
          <div
            id="TD-Following"
            style={{
              pointerEvents: 'all',
              width: 'fit-content',
              minWidth: 0,
              gridRow: 1,
              flexGrow: 2,
              display: 'block',
              fontFamily: 'Graphik Web',
            }}
          >
            <span className="text-xs text-gray-600 mt-4">
              {user?.id == spotLightUser ? `spotlight on` : `following`}&nbsp;
              <img
                className="rounded-full inline-block overflow-hidden font-medium justify-center items-center bg-cover bg-center w-20 h-20 text-xss bg-white text-primary-500"
                alt={user.user.name}
                src={user.user.avatar}
              />
            </span>
          </div>
        </div>
      )}
    </>
  );
});
